import { DEFAULT_LIQUID_DATA, Segments } from "apparatus/library/common";
import { Path } from "paper";
import { breakPath, mirrorX, setDefaultStyle } from "../../draw";
// Based on https://www.jaytecglass.co.uk/laboratory-glassware/industry-glassware/thistle-funnels/
export class ThistleTube {
    render(appearance) {
        let height = appearance.height;
        let baseShape = new Path(Segments([[16, 0]], [[10, 10], undefined, [10, 4]], [[23, 30], [0, -8], [0, 10]], [[4, 50], [8, -1]], [[4, height]]));
        mirrorX(baseShape);
        let liquidMask = baseShape.clone();
        let hitShape = baseShape.clone();
        let graphic = breakPath(baseShape, 5);
        setDefaultStyle(graphic);
        return { graphic: graphic, liquidMask: liquidMask, hitShape: hitShape };
    }
}
ThistleTube.properties = {
    label: "Thistle tube",
    canContainLiquids: true,
    defaultAppearance: {
        height: 250,
    },
    defaultLiquidData: Object.assign(Object.assign({}, DEFAULT_LIQUID_DATA), { amountRatio: 0.9 }),
    appearanceSpecs: [
        {
            spec: "slider", key: "height", label: "Height",
            min: 180, max: 300
        }
    ],
};
